import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { sendPageViewToGTM } from 'utils/seo/seoGTMUtil';

import RouteMetaContent from './RouteMetaContent';
import { ROUTE_DATA } from './routes';

/**
 * @component RouteMetaWrapper
 * @description 모든 라우트에 자동으로 SEO 메타 태그를 주입하는 래퍼 컴포넌트
 *
 * 동작 방식:
 * 1. 현재 경로를 감지
 * 2. ROUTE_DATA에서 해당 경로의 메타 키 찾기
 * 3. metaConst에서 메타 데이터 가져오기
 * 4. RouteMetaContent 컴포넌트를 통해 메타 태그 렌더링
 */
const RouteMetaWrapper = ({ meta, title, aeo, children }) => {
  const location = useLocation();

  // 페이지 로드 시 Google Tag Manager에 페이지 뷰를 전송
  useEffect(() => {
    sendPageViewToGTM(location.pathname + location.search);
  }, [location]);

  return (
    <>
      {meta ? (
        <RouteMetaContent value={meta} />
      ) : (
        title && <RouteMetaContent value={{ title, path: location.pathname }} />
      )}
      
      {aeo && (
        <div
          className="sr-only"
          aria-hidden="false"
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: 0,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            border: 0,
          }}
        >
          {aeo.tldr && (
            <aside>
              <strong>{aeo.tldr.title}</strong>
              <ul>
                {aeo.tldr.items?.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </aside>
          )}
          {aeo.description && <p>{aeo.description}</p>}
          {aeo.headings?.map((heading, i) => (
            <h2 key={i}>{heading}</h2>
          ))}
        </div>
      )}

      {children}
    </>
  );
};

export default RouteMetaWrapper;
